import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDoubleLeft = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 16,
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.33334 13L3.33334 3L6.00001 3V7.16667L12.6667 3L12.6667 13L6.00001 8.83333L6.00001 13H3.33334Z",
		fill: "currentColor"
	})]
});
export default SvgArrowDoubleLeft;
